import React, {
  FC,
  useCallback,
  useEffect,
  useState,
  Dispatch,
  SetStateAction,
} from 'react'
import { Tabs } from 'antd'
import { useHistory } from 'react-router-dom'
import styles from './style.module.scss'

const { TabPane } = Tabs

interface TabItemProps {
  chinese: string
  english: string
}

const TabItem: FC<TabItemProps> = (props: TabItemProps) => {
  const { chinese, english } = props

  return (
    <div className={styles.TabItem}>
      <div>{chinese}</div>
      <div className={styles.SubTab}>{english}</div>
    </div>
  )
}

const setHash = (hash: string, set: Dispatch<SetStateAction<string>>) => {
  if (hash) {
    set(hash.substring(1))
  } else {
    set('all')
  }
}

const NewsTab = () => {
  const [activeKey, setActiveKey] = useState('all')
  const history = useHistory()

  useEffect(() => {
    const { hash } = window.location
    setHash(hash, setActiveKey)
    history.listen((url) => {
      const { hash } = url
      setHash(hash, setActiveKey)
    })
  }, [history])

  const handleTabClick = useCallback(
    (key: string) => {
      setActiveKey(key)
      history.push(`/news#${key}`)
    },
    [history]
  )

  return (
    <div className={styles.NewsTab}>
      <Tabs
        defaultActiveKey="all"
        activeKey={activeKey}
        tabBarGutter={0}
        onTabClick={handleTabClick}
        centered
      >
        <TabPane
          tab={<TabItem chinese="全部新聞" english="NEWS" />}
          key="all"
        />
        <TabPane
          tab={<TabItem chinese="企業動態" english="INDUSTRY" />}
          key="industry"
        />
        <TabPane
          tab={<TabItem chinese="產品資訊" english="INFORMATION" />}
          key="information"
        />
        <TabPane
          tab={<TabItem chinese="歡樂活動" english="ACTIVITIES" />}
          key="activities"
        />
      </Tabs>
    </div>
  )
}

export default React.memo(NewsTab)
